export default __webpack_public_path__ + "static/media/modal_2_pet_mobile_es.581c3cc6.svg";